import {
  PageLoading,
  SnackbarApiErrorMessage,
  useDataProvider,
  useSnackbar,
} from '@ui-framework/index';
import React, {
  createContext,
  useContext,
  useMemo,
  useEffect,
  useState,
} from 'react';

const ServiceModuleContext = createContext({});

export function ServiceModuleProvider({ children }) {
  const [loading, setLoading] = useState(true);
  const [moduleSettings, setModuleSettings] = useState(false);

  const snackbar = useSnackbar();
  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const { get, getApiUrl } = useDataProvider(provider);

  const getServiceModule = async () => {
    const url = `${getApiUrl()}/sxcl/v1/service-modules`;
    const response = await get(url);
    if (response?.ok) {
      return response.data;
    }
    snackbar.showMessage({
      type: 'error',
      data: <SnackbarApiErrorMessage errors={response?.errors} />,
    });
    return null;
  };

  const initialize = async () => {
    setLoading(true);
    try {
      const serviceModuleResponse = await getServiceModule();
      setModuleSettings(serviceModuleResponse);
    } catch (err) {
      snackbar.showMessage({
        type: 'error',
        data: <SnackbarApiErrorMessage errors={[{ message: err.message }]} />,
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    initialize();
  }, []);

  const value = useMemo(() => ({ moduleSettings }), [moduleSettings]);

  if (loading) {
    return <PageLoading>Loading Service Modules...</PageLoading>;
  }

  return (
    <ServiceModuleContext.Provider value={value}>
      {children}
    </ServiceModuleContext.Provider>
  );
}

export const useServiceModule = () => {
  return useContext(ServiceModuleContext);
};
